// Paddle Integration Utility
// Based on the PHP implementation from productGPcombined.php
const PADDLE_TOKEN = process.env.PADDLE_TOKEN || '';
export const initializePaddle = () => {
    return new Promise((resolve, reject) => {
        // Check if Paddle is already loaded
        if (window.Paddle) {
            window.Paddle.Environment.set('production');
            window.Paddle.Initialize({
                token: PADDLE_TOKEN
            });
            resolve();
            return;
        }
        // Load Paddle script
        const script = document.createElement('script');
        script.src = 'https://cdn.paddle.com/paddle/v2/paddle.js';
        script.async = true;
        script.onload = () => {
            if (window.Paddle) {
                window.Paddle.Environment.set('production');
                window.Paddle.Initialize({
                    token: PADDLE_TOKEN
                });
                resolve();
            }
            else {
                reject(new Error('Paddle failed to load'));
            }
        };
        script.onerror = () => {
            reject(new Error('Failed to load Paddle script'));
        };
        document.head.appendChild(script);
    });
};
export const openPaddleCheckout = async (options) => {
    if (!window.Paddle) {
        await initializePaddle();
    }
    const passthroughData = {
        wfid: options.watchfaceId,
        item_name: options.code
    };
    const items = [
        {
            priceId: options.priceId,
            quantity: 1
        }
    ];
    window.Paddle.Checkout.open({
        items: items,
        customData: JSON.stringify(passthroughData)
    });
};
export const getPricePreview = async (priceId) => {
    if (!window.Paddle) {
        await initializePaddle();
    }
    try {
        const request = {
            items: [{
                    quantity: 1,
                    priceId: priceId
                }]
        };
        const result = await window.Paddle.PricePreview(request);
        if (result?.data?.details?.lineItems?.[0]?.formattedUnitTotals) {
            return {
                subtotal: result.data.details.lineItems[0].formattedUnitTotals.subtotal,
                tax: result.data.details.lineItems[0].formattedUnitTotals.tax
            };
        }
        return null;
    }
    catch (error) {
        if (process.env.NODE_ENV !== 'production') {
            console.error('Error getting price preview:', error);
        }
        return null;
    }
};
